/**
 * PATH: apps/qa/src/lib/offline/uploadOwnerGate.ts
 * FILE_ID: QA-OFFLINE-UPLOAD-OWNER-001
 * PURPOSE: Refuse evidence flush when queued owner != current session (P6.4).
 */

import type { PendingUpload } from './types'

export type OfflineSessionOwner = {
  userId?: string | number | null
  organisationId?: string | number | null
}

/** Legacy/unowned rows and cross-session rows must not flush under a new identity. */
export function shouldFlushUpload(
  upload: PendingUpload,
  session: OfflineSessionOwner,
): boolean {
  if (upload.ownerUserId == null || upload.ownerOrganisationId == null) {
    return false
  }
  if (session.userId == null || session.organisationId == null) {
    return false
  }
  return (
    String(upload.ownerUserId) === String(session.userId) &&
    String(upload.ownerOrganisationId) === String(session.organisationId)
  )
}
